import { CustomizationEntry } from "../types";

export enum ChatCategory {
    Appearance = 'Appearance',
    Window = 'Window',
    Header = 'Header',
    Avatars = 'Avatars',
    Conversation = 'Conversation',
    AgentMessages = 'Agent messages',
    RichContentAndActions = 'Rich content & actions',
    Composer = 'Composer',
    SystemMessages = 'System messages',
    Behavior = 'Behavior',
    Localization = 'Localization',
    Developer = 'Developer',
}

export enum ChatSubCategory {
    ThemePreset = 'Theme preset',
    Colors = 'Colors',
    BackgroundImage = 'Background image',
    Typography = 'Typography',
    SpacingAndShape = 'Spacing & shape',
    LayoutVersion = 'Layout version',
    Size = 'Size',
    Frame = 'Frame',
    Spacing = 'Spacing',
    Behavior = 'Behavior',
    Content = 'Content',
    Controls = 'Controls',
    Styling = 'Styling',
    Avatar = 'Avatar',
    Buttons = 'Buttons',
    Icons = 'Icons',
    AgentAvatar = 'Agent avatar',
    UserAvatar = 'User avatar',
    SizeAndShape = 'Size & shape',
    VisibilityInMessages = 'Visibility in messages',
    BubbleLayout = 'Bubble layout',
    AgentBubble = 'Agent bubble',
    UserBubble = 'User bubble',
    TranscriptLayout = 'Transcript layout',
    Timestamps = 'Timestamps',
    MessageStatus = 'Message status',
    TypingIndicator = 'Typing indicator',
    TranscriptControls = 'Transcript controls',
    GreetingMessage = 'Greeting message',
    InformativeMessage = 'Informative message',
    ReasoningCard = 'Reasoning card',
    HeroCards = 'Hero cards',
    HeroCardButtons = 'Hero card buttons',
    InConversationButtons = 'In-conversation buttons',
    ChoiceButtons = 'Choice buttons',
    ChoiceButtonsDisabled = 'Choice buttons (disabled)',
    ChoiceButtonLayout = 'Choice button layout',
    DropdownShell = 'Dropdown shell',
    DropdownItems = 'Dropdown items',
    Availability = 'Availability',
    Layout = 'Layout',
    Borders = 'Borders',
    ButtonColors = 'Button colors',
    Dictation = 'Dictation',
    ReplyToMessage = 'Reply to message',
    FileDropZone = 'File drop zone',
    Connectivity = 'Connectivity',
    DeliveryTimeouts = 'Delivery timeouts',
    AlertLayout = 'Alert layout',
    AlertStyling = 'Alert styling',
    StatusColors = 'Status colors',
    Integration = 'Integration',
    InterfaceText = 'Interface text',
    CustomStyling = 'Custom styling',
    EventHandlers = 'Event handlers',
    MarkupHooks = 'Markup hooks',
}

export type ChatCustomizationEntry = CustomizationEntry<ChatCategory, ChatSubCategory>;
